import { render, staticRenderFns } from "./FloorAreaShowroom.vue?vue&type=template&id=c3471f24&"
import script from "./FloorAreaShowroom.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaShowroom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports